/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, Oct 2021
 * @flow
 */

import React from 'react';
import PropTypes from 'prop-types';
import styles from './Body.module.css';
import Sensor from '../Sensor';
import Header from '../Header';

const Body = props => {
  const {
    namedSensors,
    onClickDeleteSensor,
    sortFunction,
  } = props;

  const renderSensors = () => {
    return (
      <div className={styles.sensorsWrapper}>
        {namedSensors.sort(sortFunction).map(sensor => <Sensor key={`sensorId-${sensor.id}`} sensor={sensor} onClickDeleteSensor={onClickDeleteSensor} />)}
      </div>
    );
  };

  return (
    <div className={styles.container}>
      <Header {...props} />
      <div className={styles.contentWrapper}>
        {renderSensors()}
      </div>
    </div>
  );
};

export default Body;

Body.propTypes = {
  namedSensors: PropTypes.array,
  onClickDeleteSensor: PropTypes.func,
  sortFunction: PropTypes.func,
};

Body.defaultProps = {
  namedSensors: [],
  onClickDeleteSensor: () => { },
  sortFunction: () => { },
};
